import { legacy_createStore as createStore, applyMiddleware, compose } from 'redux';
import { thunk } from 'redux-thunk';
import RootReducer from '../reducers';
import { persistStore } from 'redux-persist';

// Redux DevTools only in local development (yarn start); never on built servers.
const composeEnhancers =
    (process.env.NODE_ENV !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

export const store = createStore(
    RootReducer,
    composeEnhancers(applyMiddleware(thunk)),
);
export const persistor = persistStore(store);
export default { store, persistor };